import type { StoryCatalog } from './types';

export const STORY_SAMPLE_CATALOG: StoryCatalog = {
  version: 1,
  updatedAt: '2026-04-22T01:56:50.668Z',
  defaults: {
    frameStyleIds: ['none', 'white', 'rainbow', 'pastel'],
    playModes: ['simultaneous', 'sequential'],
    captureDurationMs: 5000,
    titleMessageLine1: {
      ko: '📹 우리 아이의 하루를 5초 영상으로 기록해요',
      en: "📹 Capture your baby's day in a 5-second story",
      ja: '📹 赤ちゃんの一日を5秒動画で記録しましょう',
    },
    subtitleMessage: {
      ko: '가로 영상을 올려주시거나 직접 가로로 촬영해보세요!',
      en: 'Upload a landscape video or record one directly in landscape mode.',
      ja: '横向き動画をアップロードするか、そのまま横向きで撮影してみてください。',
    },
    layoutPresetsBySlotCount: {
      '3': [
        'stack-3',
        'hero-top-2-bottom',
        'hero-bottom-2-top',
        'left-large-right-stack',
        'right-large-left-stack',
      ],
      '4': [
        'stack-4',
        'grid-2x2',
        'hero-top-3-bottom',
        'hero-bottom-3-top',
      ],
    },
  },
  categories: [
    {
      id: 'test',
      sortOrder: 10,
      enabled: true,
      title: {
        ko: '1',
        en: '2',
        ja: '3',
      },
    },
  ],
  templates: [
    {
      id: 'eat',
      categoryId: 'test',
      sortOrder: 10,
      enabled: true,
      iconKey: '🍼',
      title: {
        ko: '1',
        en: '2',
        ja: '3',
      },
      description: {
        ko: '샘플 3분할 프리셋',
        en: 'Sample 3-slot preset',
        ja: 'サンプル3分割プリセット',
      },
      slotCount: 3,
      layout: {
        type: 'preset',
        preset: 'stack-3',
      },
      slots: [
        {
          id: 'slot-1',
          label: {
            ko: '슬롯 1',
            en: 'Slot 1',
            ja: 'スロット 1',
          },
        },
        {
          id: 'slot-2',
          label: {
            ko: '슬롯 2',
            en: 'Slot 2',
            ja: 'スロット 2',
          },
        },
        {
          id: 'slot-3',
          label: {
            ko: '슬롯 3',
            en: 'Slot 3',
            ja: 'スロット 3',
          },
        },
      ],
      defaults: {
        frameStyleId: 'none',
        playMode: 'simultaneous',
      },
    },
  ],
};
